export const SAVED = 'SAVED';
export const CONFIRM_TYPE = 'CONFIRM_TYPE';
export const FILEPATH = 'FILEPATH';
export const FILE = 'FILE';
export const RENAME = 'RENAME';
export const SYNC_PROJECTS = 'SYNC_PROJECTS';
export const OPEN_PROJECT = 'OPEN_PROJECT';
export const DOWNLOAD_PROJECT = 'DOWNLOAD_PROJECT';
export const UPLOAD_PROJECT = 'UPLOAD_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const COPY_PROJECT = 'COPY_PROJECT';
export const SHARE_PROJECT = 'SHARE_PROJECT';
export const UPLOAD_COVERIMG = 'UPLOAD_COVERIMG';
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS';
export const SEARCH = 'SEARCH';
export const UPDATE_PRE_PROJECT_DATA_STRING = 'UPDATE_PRE_PROJECT_DATA_STRING';
export const UPDATE_PROJECT_LOADED_STATE = 'UPDATE_PROJECT_LOADED_STATE';
